import { StateManager } from 'AppReact';

const stateManager = StateManager([
  {
    name: 'noteDescription',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    show: (_, { description }) => { return `/api/notes?getUpdatedCat&note=${description}` }
  }
])

const matchCategoriesToResult = (categories, result) => {
  if (!result || !result.length || !categories || !categories.length) return [];
  return result.map((r) => {
    const cat = categories.find(c => c.id === parseInt(r.displayName));
    return { ...cat, classification: r.classification.score };
  })
    .filter((item) => item.id)
};

export const getSuggestedCategories = async (
  description,
  subcategories,
  count = 0
) => {
  if (description) {
    if (count > 2) return [];
    try {
      let trimmedDescription = description.replace(/^\s+/, '');
      if (trimmedDescription?.[0] === '#') {
        trimmedDescription = trimmedDescription.substring(1)
      }
      if (description.length > 2 && trimmedDescription.length > 0) {
        const result = await stateManager.fetchNoteDescription({ description: trimmedDescription });
        const categories = matchCategoriesToResult(subcategories, result.data);
        return categories;
      }
      return [];
    } catch (e) {
      return getSuggestedCategories(description, subcategories, count + 1)
    }
  }
  return [];
};